import { http } from '@pequity/shared/axios/http';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, toValue } from 'vue';
import type { AiChatHistoryMessage, QuestionExample } from '@/ai-assistant/components/ai-chat/ai-chat.types';

type ThreadResponse = {
  id: string;
  name: string;
};

export const useThreadsQuery = () => {
  return useQuery({
    queryKey: ['ai-assistant', 'threads'],
    queryFn: async () => {
      const res = await http.get<ThreadResponse[]>('ai-assistant/threads');
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useConversationHistoryQuery = (
  threadId: MaybeRef<string | null>,
  options: { enabled: MaybeRef<boolean> } = { enabled: true }
) => {
  return useQuery({
    queryKey: ['ai-assistant', 'conversation', threadId],
    queryFn: async () => {
      const id = toValue(threadId);
      const res = await http.get<AiChatHistoryMessage[]>(`ai-assistant/threads/${id}`);
      return res.data;
    },
    enabled: options.enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useQuestionExamplesQuery = () => {
  return useQuery({
    queryKey: ['ai-assistant', 'question-examples'],
    queryFn: async () => {
      const res = await http.get<QuestionExample[]>('ai-assistant/question-examples');
      return res.data;
    },
  });
};
